function enter(page, num) {
	const slides = $('[data-slide]');
	const $parent = $('body [data-page="home"]');
	let $page = $(`body [data-slide="${page}"]`);

	if (typeof num !== 'undefined') {
		$page = $(`[data-slide="${page}-${num}"]`);
	}

	return new Promise((resolve) => {
		slides.addClass('is-hidden');
		$parent.removeClass('is-hidden');
		$page.removeClass('is-hidden');
		resolve();
	});
}

function leave(page, num) {
	let $page = $(`body [data-slide="${page}"]`);

	if (typeof num !== 'undefined') {
		$page = $(`[data-slide="${page}-${num}"]`);
	}

	return new Promise((resolve) => {
		$page.addClass('is-hidden');
		resolve();
	});
}

function reset() {
	return new Promise((resolve) => {
		$('body [data-page="home"]').addClass('is-hidden');
		$('body [data-slide]').addClass('is-hidden');
		$('body [data-slide="home"]').removeClass('is-hidden');
		resolve();
	});
}

export default {
	enter,
	leave,
	reset,
};
